export const googlePlaceImage = (name?: string) => ['placeImage', name] as const
export const googlePlaceImages = (
  placeId: string,
  count: number = 1,
  orientation: 'landscape' | 'portrait' | 'all' = 'all',
  maxWidthPx?: number,
) => ['placeImages', placeId, count, orientation, maxWidthPx] as const
